export const allDomains = [
  'activeden.net',
  'audiojungle.net',
  'themeforest.net',
  'videohive.net',
  'graphicriver.net',
  '3docean.net',
  'codecanyon.net',
  'photodune.net',
  'market.envato.com',
  'market.styleguide.envato.com',
  'elements.envato.com',
  'build.envatohostedservices.com',
  'author.envato.com',
  'envato.com'
]

export enum Site {
  'themeforest' = 'themeforest',
  'codecanyon' = 'codecanyon',
  'videohive' = 'videohive',
  'audiojungle' = 'audiojungle',
  'graphicriver' = 'graphicriver',
  'photodune' = 'photodune',
  'threedocean' = '3docean'
}

// The order of exported sites determines the order of logotypes
// in the header.
export const siteNames = [
  Site.themeforest,
  Site.codecanyon,
  Site.videohive,
  Site.audiojungle,
  Site.graphicriver,
  Site.photodune,
  Site.threedocean
]
